import { LINKS } from '@fans-fund-me/shared-comm-react-cosmos/fans-fund-me/links';
import { Screen } from '@fans-fund-me/shared-comm-react-cosmos/fans-fund-me/login-screen';
import { useAuth } from '@fans-fund-me/shared-common-esm-authentication';
import { useForm } from '@mantine/form';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { FORM_ERRORS } from '../../constants/form_errors.ts';

function Login() {
  const auth = useAuth();
  const navigate = useNavigate();

  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const form = useForm({
    mode: 'uncontrolled',
    initialValues: {
      email_address: '',
      password: '',
    },
    validate: {
      email_address: (value) => (/^\S+@\S+$/.test(value) ? null : FORM_ERRORS.EMAIL_INVALID),
    },
  });

  form.watch('email_address', () => {
    form.clearErrors();
  });

  form.watch('password', () => {
    form.clearErrors();
  });

  useEffect(() => {
    if (isLoggedIn && auth.details && auth.details['username'] !== undefined) {
      navigate(`/${auth.details['username']}`);
    } else if (isLoggedIn) {
      navigate(LINKS.HOME);
    }
  }, [isLoggedIn, auth.details, navigate]);

  const handleSubmit = (values: typeof form.values) => {
    auth
      .login({ email: values.email_address, password: values.password })
      .then(() => {
        setIsLoggedIn(true);
      })
      .catch((error) => {
        if (error.errorType === 'UNAUTHORISED') {
          form.setErrors({
            email_address: ' ',
            password: 'Your email address or password is incorrect',
          });
        } else {
          console.error('Error submitting login form', JSON.stringify(error));
        }
      });
  };

  return <Screen form={form} handleSubmit={handleSubmit} />;
}

export default Login;
